import { DateTime } from 'luxon';

export default timezone => {
  const nowInTimezone = DateTime.local().setZone(timezone);
  return nowInTimezone.setZone('local', { keepLocalTime: true }).toJSDate();
};
